(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-cinema-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('[data-mj-cinema-hero]');
    if (!roots.length) return;

    roots.forEach(function(root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mj-hero-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mj-hero-dot]'));
      var prev = root.querySelector('[data-mj-hero-prev]');
      var next = root.querySelector('[data-mj-hero-next]');
      var controls = root.querySelector('.mj-ch-controls');
      var activeIndex = 0;
      var timer = null;
      var interval = parseInt(root.getAttribute('data-mj-hero-interval'), 10) || 7000;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = root.getAttribute('data-mj-hero-autoplay') === 'true' && slides.length > 1 && !reduceMotion;
      var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

      function isAllowedForDevice(element) {
        var setting = element.getAttribute('data-mj-device') || 'all';
        if (setting === 'all') return true;
        var isMobile = mobileQuery ? mobileQuery.matches : window.innerWidth < 750;
        return isMobile ? setting === 'mobile' : setting === 'desktop';
      }

      function getEligibleSlides() {
        return slides.filter(isAllowedForDevice);
      }

      function isVisibleMedia(media) {
        return window.getComputedStyle(media).display !== 'none';
      }

      function getSlideVideos(slide) {
        return Array.prototype.slice.call(slide.querySelectorAll('[data-mj-hero-video]'));
      }

      function getPrimaryVideo(slide) {
        var videos = getSlideVideos(slide);
        return videos.find(isVisibleMedia) || videos[0] || null;
      }

      function setSoundButton(button, muted) {
        var label = button.querySelector('span') || button;
        button.setAttribute('aria-pressed', muted ? 'false' : 'true');
        label.textContent = muted ? 'Sound' : 'Mute';
      }

      function syncVideos(index) {
        var eligibleSlides = getEligibleSlides();
        var activeSlide = eligibleSlides[index];

        slides.forEach(function(slide, slideIndex) {
          getSlideVideos(slide).forEach(function(video) {
            if (slide === activeSlide && isVisibleMedia(video)) {
              video.play().catch(function() {});
            } else {
              video.pause();
            }
          });
        });
      }

      function updateSoundButtons() {
        root.querySelectorAll('[data-mj-hero-sound]').forEach(function(button) {
          var slide = button.closest('[data-mj-hero-slide]');
          var video = slide ? getPrimaryVideo(slide) : null;
          if (!video) return;
          setSoundButton(button, video.muted);
        });
      }

      function showSlide(index) {
        var eligibleSlides = getEligibleSlides();
        if (!eligibleSlides.length) {
          slides.forEach(function(slide) {
            slide.classList.remove('is-active');
            slide.setAttribute('aria-hidden', 'true');
          });

          if (controls) controls.hidden = true;
          return;
        }

        activeIndex = (index + eligibleSlides.length) % eligibleSlides.length;
        var activeSlide = eligibleSlides[activeIndex];

        slides.forEach(function(slide) {
          var active = slide === activeSlide;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach(function(dot) {
          var dotSlide = slides[parseInt(dot.getAttribute('data-slide-index'), 10) || 0];
          var active = dotSlide === activeSlide;
          var allowed = isAllowedForDevice(dot);
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
          dot.hidden = !allowed;
        });

        if (controls) controls.hidden = eligibleSlides.length <= 1;
        syncVideos(activeIndex);
        updateSoundButtons();
      }

      function pauseAllVideos() {
        slides.forEach(function(slide) {
          getSlideVideos(slide).forEach(function(video) {
            video.pause();
          });
        });
      }

      function stopAutoplay() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        if (!autoplay || timer) return;
        timer = window.setInterval(function() {
          showSlide(activeIndex + 1);
        }, interval);
      }

      root.querySelectorAll('[data-mj-hero-sound]').forEach(function(button) {
        var slide = button.closest('[data-mj-hero-slide]');
        var video = slide ? getPrimaryVideo(slide) : null;

        if (video) setSoundButton(button, video.muted);
        button.addEventListener('click', function() {
          video = slide ? getPrimaryVideo(slide) : null;
          if (!video) return;
          video.muted = !video.muted;
          setSoundButton(button, video.muted);
        });
      });

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var dotSlide = slides[parseInt(dot.getAttribute('data-slide-index'), 10) || 0];
          var eligibleSlides = getEligibleSlides();
          var eligibleIndex = eligibleSlides.indexOf(dotSlide);
          if (eligibleIndex < 0) return;

          stopAutoplay();
          showSlide(eligibleIndex);
          startAutoplay();
        });
      });

      if (prev) {
        prev.addEventListener('click', function() {
          stopAutoplay();
          showSlide(activeIndex - 1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function() {
          stopAutoplay();
          showSlide(activeIndex + 1);
          startAutoplay();
        });
      }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);

      if (mobileQuery) {
        mobileQuery.addEventListener('change', function() {
          pauseAllVideos();
          showSlide(0);
        });
      } else {
        window.addEventListener('resize', function() {
          pauseAllVideos();
          showSlide(0);
        });
      }

      showSlide(0);
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-shop-by"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var roots = document.querySelectorAll('.mj-sb');
    if (!roots.length) return;

    roots.forEach(function(root) {
      var tabs   = root.querySelectorAll('.mj-sb__tab');
      var panels = root.querySelectorAll('.mj-sb__panel');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = this.dataset.tab;

          tabs.forEach(function(t) {
            t.classList.remove('mj-sb__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function(p) { p.classList.remove('mj-sb__panel--active'); });

          this.classList.add('mj-sb__tab--active');
          this.setAttribute('aria-selected', 'true');
          var panel = root.querySelector('.mj-sb__panel[data-panel="' + target + '"]');
          if (panel) panel.classList.add('mj-sb__panel--active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj-shoppable-film"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var roots = document.querySelectorAll('.mj-sf');
    if (!roots.length) return;

    roots.forEach(function(root) {
      var selectors = root.querySelectorAll('[data-still-selector]');
      var panels = root.querySelectorAll('[data-still-panel]');
      var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

      function isAllowedForDevice(element) {
        var setting = element.getAttribute('data-mj-device') || 'all';
        if (setting === 'all') return true;
        var isMobile = mobileQuery ? mobileQuery.matches : window.innerWidth < 750;
        return isMobile ? setting === 'mobile' : setting === 'desktop';
      }

      function showPanel(index) {
        var panel = root.querySelector('[data-still-panel="' + index + '"]');
        if (!panel || !isAllowedForDevice(panel)) return;

        selectors.forEach(function(item) {
          var allowed = isAllowedForDevice(item);
          item.hidden = !allowed;
          item.classList.remove('mj-sf__selector--active');
          item.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function(item) {
          item.classList.remove('mj-sf__panel--active');
        });

        var selector = root.querySelector('[data-still-selector="' + index + '"]');
        if (selector) {
          selector.classList.add('mj-sf__selector--active');
          selector.setAttribute('aria-selected', 'true');
        }

        panel.classList.add('mj-sf__panel--active');
      }

      function showFirstEligiblePanel() {
        var first = Array.prototype.slice.call(panels).find(isAllowedForDevice);
        if (!first) return;
        showPanel(first.getAttribute('data-still-panel'));
      }

      selectors.forEach(function(selector) {
        selector.addEventListener('click', function() {
          var index = selector.getAttribute('data-still-selector');
          showPanel(index);
        });
      });

      if (mobileQuery) {
        mobileQuery.addEventListener('change', showFirstEligiblePanel);
      } else {
        window.addEventListener('resize', showFirstEligiblePanel);
      }

      showFirstEligiblePanel();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
